import { escapeText } from 'quill/blots/text';
import type Quill from 'quill/core';
import type { Range } from 'quill/core';
import { Delta } from 'quill/core';
import QuillClipboard from 'quill/modules/clipboard';
import type CodeEmbed from '../formats/CodeEmbed';

class CodeEmbedEditorClipboard extends QuillClipboard {
  blot: CodeEmbed;

  constructor(quill: Quill, { blot }: { blot: CodeEmbed }) {
    super(quill, { matchers: [] });
    this.blot = blot;
  }

  onCopy(range: Range) {
    const [line, offset] = this.quill.getLine(range.index);
    if (line) {
      const remainingLength = line.length() - 1 - offset;
      const isWholeLineSelected =
        range.length > remainingLength ||
        (range.length === remainingLength && offset === 0);

      if (!isWholeLineSelected) {
        const text = this.blot.code(range);
        return { html: `<code>${escapeText(text)}</code>`, text };
      }
    }
    return { html: this.blot.html(range), text: this.blot.code(range) };
  }

  convert({ text }: { text?: string }) {
    return new Delta().insert(text || '');
  }
}

export default CodeEmbedEditorClipboard;
